import React from 'react';
import { Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

export const ButtonBack = ({ onClick, ...rest }) => (
  <Button size="small" color={'primary'} onClick={onClick} startIcon={<ArrowBackIcon />} {...rest} />
);
